import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Card,
  Typography,
  Alert,
  Layout,
  Menu,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { requestPasswordReset } from "../services/authService";

const { Title } = Typography;
const { Header, Content } = Layout;

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const menuItems = [
    {
      key: "1",
      label: (
        <Link to="/dashboard">
          <span>Dashboard</span>
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link to="/sign-up">
          <span>Sign Up</span>
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link to="/sign-in">
          <span>Sign In</span>
        </Link>
      ),
    },
  ];

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      setError("");
      await requestPasswordReset(values.email);
      setSuccess(true);
      // Don't auto-redirect, let user read the success message
    } catch (err) {
      const errorMsg = err.response?.data?.message;
      if (err.response?.status === 404) {
        setError("No account found with this email address.");
      } else if (err.response?.status === 429) {
        setError("Too many reset attempts. Please try again later.");
      } else {
        setError(errorMsg || "Failed to send reset link. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="layout-default" style={{ minHeight: '100vh' }}>
      <Header>
        <div className="header-col header-brand">
          <h5>Arriva Admin Portal</h5>
        </div>
        <div className="header-col header-nav">
          <Menu mode="horizontal" defaultSelectedKeys={[]} items={menuItems} />
        </div>
      </Header>

      <Content className="signin" style={{ 
        background: '#f5f5f5',
        padding: '0',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 64px)' // Account for header height
      }}>
        {/* Header Section */}
        <div className="sign-in-header" style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '50px 20px 35px',
          textAlign: 'center',
          flexShrink: 0
        }}>
          <div className="content" style={{
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            <Title style={{ 
              color: 'white', 
              fontSize: '2.2rem',
              fontWeight: '600',
              marginBottom: '16px',
              lineHeight: '1.2'
            }}>
              Forgot Password
            </Title>
            <p style={{
              fontSize: '1rem',
              color: 'rgba(255, 255, 255, 0.9)',
              lineHeight: '1.5',
              maxWidth: '450px',
              margin: '0 auto'
            }}>
              Enter your email and we'll send you instructions to reset your password
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div style={{ 
          flex: 1,
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'flex-start',
          padding: '30px 20px 40px',
          transform: 'translateY(-15px)' // Pull card up slightly
        }}>
                      <Card 
              className="card-signin" 
              style={{ 
                width: '100%', 
                maxWidth: '480px',
                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                borderRadius: '12px',
                border: 'none',
                overflow: 'hidden'
              }}
            >
              <div style={{ padding: '24px 32px 32px' }}>
              {error && (
                <Alert
                  message="Error"
                  description={error}
                  type="error"
                  showIcon
                  style={{ 
                    marginBottom: 24,
                    borderRadius: '8px'
                  }}
                />
              )}

              {success ? (
                <div style={{ textAlign: 'center', padding: '16px 0' }}>
                  <div style={{ 
                    fontSize: '48px', 
                    color: '#52c41a', 
                    marginBottom: '16px' 
                  }}>
                    ✓
                  </div>
                  <Title level={3} style={{ 
                    color: '#52c41a', 
                    marginBottom: '16px',
                    fontWeight: 600
                  }}>
                    Reset Link Sent
                  </Title>
                                     <p style={{ 
                     color: '#666', 
                     fontSize: '15px', 
                     lineHeight: '1.6',
                     marginBottom: '24px',
                     maxWidth: '100%',
                     margin: '0 auto 24px'
                   }}>
                     Please check your email for instructions to reset your password.<br />
                     Click the link in the email to set a new password.
                   </p>
                  <Button 
                    type="primary" 
                    onClick={() => navigate("/sign-in")}
                    style={{ marginRight: '12px' }}
                  >
                    Back to Sign In
                  </Button>
                                <Button 
                type="default" 
                onClick={() => window.location.reload()}
              >
                Resend Link
              </Button>
                </div>
              ) : (
                <div>
                  <Title level={3} style={{
                    textAlign: 'center',
                    marginBottom: '8px',
                    color: '#333',
                    fontWeight: '600',
                    fontSize: '1.4rem'
                  }}>
                    Reset Your Password
                  </Title>
                                     <p style={{
                     textAlign: 'center',
                     color: '#666',
                     marginBottom: '28px',
                     fontSize: '14px',
                     lineHeight: '1.5',
                     maxWidth: '100%'
                   }}>
                     Enter your email address and we'll send you<br />
                     a link to reset your password
                   </p>

                  <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                    requiredMark={false}
                  >
                    <Form.Item
                      name="email"
                      label={<span style={{ fontWeight: '500', color: '#333', fontSize: '14px' }}>Email Address</span>}
                      rules={[
                        { required: true, message: "Please input your email!" },
                        { type: "email", message: "Please enter a valid email!" },
                      ]}
                      style={{ marginBottom: '20px' }}
                    >
                      <Input 
                        placeholder="Enter your email address" 
                        size="large"
                        style={{ 
                          borderRadius: '6px',
                          height: '44px',
                          fontSize: '14px'
                        }}
                        className="input-with-better-placeholder"
                      />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: '20px' }}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        size="large"
                        block
                        style={{
                          borderRadius: '6px',
                          height: '44px',
                          fontWeight: '500',
                          fontSize: '15px',
                          background: '#4f7cff',
                          borderColor: '#4f7cff'
                        }}
                      >
                        Send Reset Link
                      </Button>
                    </Form.Item>

                    <div style={{ textAlign: "center", marginTop: '20px' }}>
                      <Button 
                        type="link" 
                        onClick={() => navigate("/sign-in")}
                        style={{
                          color: '#666',
                          fontWeight: '500',
                          fontSize: '14px',
                          padding: '4px 0'
                        }}
                      >
                        ← Back to Sign In
                      </Button>
                    </div>
                  </Form>
                </div>
              )}
            </div>
          </Card>
        </div>
      </Content>

      <style jsx>{`
        .input-with-better-placeholder input::placeholder {
          color: #999 !important;
          opacity: 1 !important;
        }
        
        .input-with-better-placeholder input::-webkit-input-placeholder {
          color: #999 !important;
          opacity: 1 !important;
        }
        
        .input-with-better-placeholder input::-moz-placeholder {
          color: #999 !important;
          opacity: 1 !important;
        }
        
        .input-with-better-placeholder input:-ms-input-placeholder {
          color: #999 !important;
          opacity: 1 !important;
        }
      `}</style>
    </Layout>
  );
};

export default ForgotPassword;